var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.auth.user.selectedAccess.roleLevel > 1)?_c('div',[_c('app-header',{attrs:{"title":_vm.$store.getters['translations/getLabel']('SUBDISTRIBUTORS')}}),_c('b-container',[_c('SubdistributorList')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }